import { render, staticRenderFns } from "./WorkspaceRemoveModal.vue?vue&type=template&id=5b126f9a&lang=html&"
import script from "./WorkspaceRemoveModal.vue?vue&type=script&lang=js&"
export * from "./WorkspaceRemoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports